module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_intro_list02-94f7a6a4dfcc451c4ea89d5e974b220f.png";